import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "11",
  height: "13",
  viewBox: "0 0 11 13",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.22222 11.1429C1.22222 12.0508 2.19127 13 3.05556 13H7.94444C8.80873 13 9.77778 12.0508 9.77778 11.1429V3.09524H1.22222V11.1429ZM2.35714 4.33333H8.64286V10.7619C8.64286 11.3142 8.19514 11.7619 7.64286 11.7619H3.35714C2.80486 11.7619 2.35714 11.3142 2.35714 10.7619V4.33333ZM7.33333 0.619048L6.72222 0H4.27778L3.66667 0.619048H0L0 1.85714H11V0.619048H7.33333Z",
  fill: "fill-color"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}